import {createContext, useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from '@/lib/auth';

const Context = createContext({mode:'civil',dual:false});
export const useFieldWorkMode = () => useContext(Context);
export function FieldWorkModeProvider({children}) {
  const {user} = useAuth();
  const location = useLocation(), navigate = useNavigate();
  const field = user?.role === 'field';
  const dual = field && !!user?.truck_driver;
  const key = `fieldlink:work-mode:${user?.org_id}:${user?.id}`;
  const [choice,setChoice] = useState({key:null,value:null});
  let saved = null;
  try {saved=localStorage.getItem(key);} catch {}
  const preferred = choice.key === key ? choice.value : saved;
  const path = location.pathname;
  const contextMode = /^\/app\/(my-runs|running-sheets|trucking-time)(\/|$)/.test(path) ? 'trucking' : /^\/app\/(jobs|timesheets|crew-needs)(\/|$)/.test(path) ? 'civil' : null;
  const mode = !dual ? 'civil' : contextMode || (['civil','trucking'].includes(preferred) ? preferred : null);
  const remember = value => {setChoice({key,value});try {localStorage.setItem(key,value);} catch {}};
  useEffect(() => {
    if(dual && contextMode && preferred !== contextMode) remember(contextMode);
    if(field && !dual) {try {localStorage.removeItem(key);} catch {}}
    // Context follows authorized capability data, never grants capability.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[key,dual,field,contextMode,preferred]);
  const select = value => {
    if(!field || !['civil','trucking'].includes(value) || value === 'trucking' && !dual) return;
    remember(value);navigate(value === 'trucking' ? '/app/my-runs' : '/app');
  };
  return <Context.Provider value={{mode,dual,select}}>{children}</Context.Provider>;
}
export function FieldWorkModeChooser() {
  const {select}=useFieldWorkMode();
  return <section className="p-5 space-y-4"><h1 className="text-2xl font-semibold">What are you doing today?</h1><p className="text-sm text-muted-foreground">Choose your Fieldlink workspace.</p>{[['civil','Civil Fieldwork','Jobs, site work, timesheets and safety'],['trucking','Trucking','Runs, loads, dockets and pre-starts']].map(([value,label,help])=><button key={value} onClick={()=>select(value)} className="block w-full text-left p-5 rounded-xl border border-border bg-card focus-visible:ring-2 focus-visible:ring-[#FF5F15]"><strong className="text-lg">{label}</strong><span className="block text-sm text-muted-foreground mt-1">{help}</span></button>)}</section>;
}
export function FieldWorkModeSwitch({onSelected}) {
  const {mode,dual,select}=useFieldWorkMode();
  if(!dual)return null;
  return <label className="block text-sm p-3">Work mode<select aria-label="Work mode" className="block w-full min-h-12 border border-border rounded-md bg-background text-foreground px-3 mt-1" value={mode || ''} onChange={e=>{select(e.target.value);onSelected?.();}}><option value="" disabled>Choose workspace</option><option value="civil">Civil Fieldwork</option><option value="trucking">Trucking</option></select></label>;
}
